export default __webpack_public_path__ + "static/media/checkIcon.f9975c9e.svg";